import { render, staticRenderFns } from "./Lessons.vue?vue&type=template&id=9535e7ec&scoped=true"
import script from "./Lessons.vue?vue&type=script&lang=js"
export * from "./Lessons.vue?vue&type=script&lang=js"
import style0 from "./Lessons.vue?vue&type=style&index=0&id=9535e7ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9535e7ec",
  null
  
)

export default component.exports